import { findKey } from 'lodash';
import {
  CampaignOverviewKindType,
  UIFilterCampaignKindType,
} from '../model/CampaignOverviewModel';

export const campaignFilterMap: Record<
  CampaignOverviewKindType,
  UIFilterCampaignKindType
> = {
  all: 'all',
  blaster: 'chat_blaster',
  drip: 'drip_campaigns',
  ctm_ads: 'ctm_ads',
  legacy_messenger_ads: 'legacy_messenger_ads',
  sponsored: 'sponsored_messages',
  rss: 'rss_blasts',
  automation: 'automation',
};

export const mapCampaignOverviewKindToUIFilterKind = (
  kind: CampaignOverviewKindType,
): UIFilterCampaignKindType => campaignFilterMap[kind];

export const mapUIFilterKindToCampaignOverviewKind = (
  kind: UIFilterCampaignKindType,
) => {
  const match = findKey(campaignFilterMap, v => v === kind);
  return match ? (match as CampaignOverviewKindType) : undefined;
};
